import { useState } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FadeInSection from '../components/FadeInSection';
import { Link } from 'react-router-dom';
import TheApp from '../components/TheApp';
import { Helmet } from "react-helmet-async";





export default function Discover() {
 
   const isLaunched = false;
  const [activeFilter, setActiveFilter] = useState('Everyday Fit');
  const [selectedOutfit, setSelectedOutfit] = useState(null);

 const outfitData = [
  {
    id: 1,
    fitCategory: "SUMMER FIT",
   
    image: "../../img/discover-1.webp"
  },
  {
    id: 2,
    fitCategory: "PARTY FIT",
   
     image: "../../img/discover-2.webp"
  },
  {
    id: 3,
    fitCategory: "EVERYDAY FIT",
   
     image: "../../img/discover-3.webp"
  },
  {
    id: 4,
    fitCategory: "PARTY FIT",
    
     image: "../../img/discover-4.webp"
  },
  {
    id: 5,
    fitCategory: "SUMMER FIT",
    
     image: "../../img/discover-5.webp"
  },
  {
    id: 6,
    fitCategory: "DATE FIT",
    
    image: "../../img/discover-6.webp"
  },

    {
    id: 7,
    fitCategory: "EVERYDAY FIT",
    
    image: "../../img/discover-7.webp"
  },

    {
    id: 8,
    fitCategory: "EVERYDAY FIT",
    
    image: "../../img/discover-8.webp"
  },

    {
    id: 9,
    fitCategory: "EVERYDAY FIT",
    
    image: "../../img/discover-9.webp"
  },

    {
    id: 10,
    fitCategory: "WORK FIT",
    
    image: "../../img/discover-10.webp"
  },

    {
    id: 11,
    fitCategory: "SUMMER FIT",
    
    image: "../../img/discover-11.webp"
  },

    {
    id: 12,
    fitCategory: "PARTY FIT",
    
    image: "../../img/discover-12.webp"
  },

    {
    id: 13,
    fitCategory: "WORK FIT",
    
    image: "../../img/discover-13.webp"
  },

      {
    id: 14,
    fitCategory: "WORK FIT",
    
    image: "../../img/discover-14.webp"
  },


 
 
];




  // Dynamic filter tags derived from data
  const filters = ['SELECT ALL', 'Everyday Fit', 'Summer Vacation Fit', 'Party Fit', 'Date Fit', 'Work Fit'];

  // Filter logic
  const filteredOutfits = outfitData.filter(item => {
    if (activeFilter === 'SELECT ALL') return true;
    if (activeFilter === 'Everyday Fit') return item.fitCategory.toUpperCase() === 'EVERYDAY FIT';
    if (activeFilter === 'Summer Vacation Fit') return item.fitCategory.toUpperCase() === 'SUMMER FIT';
    if (activeFilter === 'Party Fit') return item.fitCategory.toUpperCase() === 'PARTY FIT';
    if (activeFilter === 'Date Fit') return item.fitCategory.toUpperCase() === 'DATE FIT';
    if (activeFilter === 'Work Fit') return item.fitCategory.toUpperCase() === 'WORK FIT';
    return false;
  });

  return (
    <>
     <Helmet>
            <title>OutfitFind Discover| Discover Fashion, Outfits & Style </title>
           <meta
            name="description"
            content="Discover trending fashion, stylish outfits, and must-have looks on OutfitFind. Find your style and shop your favorite fashion online."
          />
                </Helmet>
      <Header />
      <main>
<section className="discover-section" style={{ paddingTop: '10rem' }}>
      <div className="container">
        
        {/* Header */}
        <div className="text-center mb-5">
          <div className="section-eyebrow">DISCOVER YOUR NEXT LOOK</div>
          <h2 className="section-title">
            Outfits for <span className="italic">every plan.</span>
          </h2>
          <p className="section-subtitle">
            Explore professionally styled looks for every mood, moment and occasion.
          </p>
        </div>

        {/* Dynamic Category Filter */}
        <FadeInSection className="category-filter mb-5">
          {filters.map(filter => (
            <button
              key={filter}
              className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </FadeInSection>

        {/* Pinterest-Style Editorial Masonry Grid */}
        <FadeInSection className="row">
          {filteredOutfits.map((outfit) => (
              <div class="col-md-4">
                  <div 
              key={outfit.id} 
              className="editorial-masonry-item"
              onClick={() => setSelectedOutfit(outfit)}
             >
              <div className="outfit-card-container">
                <img 
                  src={outfit.image} 
                  alt={`${outfit.fitCategory} - ${outfit.situationName}`} 
                  className="outfit-masonry-img" 
                />
                
                {/* Hover Overlay */}
                <div className="outfit-card-overlay">
                  <div className="explore-look-btn">
                   
                      <a href="#" className="text-white text-decoration-none">
                        <i className="bi bi-search me-2"></i>  Look
                      </a>
                  </div>
                  
                  {/* Minimal Text Footer */}
                  <div className="outfit-card-info">
                    <span className="outfit-fit-tag">{outfit.fitCategory}</span>
                    <h3 className="outfit-situation-title">{outfit.situationName}</h3>
                  </div>
                </div>
              </div>
            </div>
              </div>
          ))}
        </FadeInSection>

        {/* CTA Button */}
        <div className="text-center mt-5 fade-in visible">
          <Link to="#" className="btn-outline-peach">
            EXPLORE MORE IN THE OUTFITFIND APP
          </Link>
        </div>

       

      </div>
    </section>



        







       <TheApp />

         <section className="cta-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8 col-md-10 text-center">
            
            <div className="cta-card">
              {/* Question Heading */}
              <h2 className="cta-heading">
                Want to see <span>OutfitFind</span> in action?
              </h2>

              {/* Status / Button Container */}
              <div className="d-flex justify-content-center mt-3">
                {!isLaunched ? (
                  /* FOR NOW: COMING SOON STATE */
                  <div className="cta-badge-pill">
                    <i className="bi bi-clock-history"></i>
                    <span>APP COMING SOON</span>
                  </div>
                ) : (
                  /* AFTER LAUNCH: LIVE LINK STATE */
                  <a href="https://outfitfind.app" className="btn-cta-explore">
                    <span>EXPLORE THE APP</span>
                    <i className="bi bi-arrow-right"></i>
                  </a>
                )}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
      </main>
      <Footer />
    </>
  );
}


